module.exports = __webpack_public_path__ + "static/media/img-access-map-ko-KR.f7a2d149.jpg";